import Controller from "./captains.controller";
import template from "./captains.html";

const captains = {
  template,
  controller: Controller,
};

export default captains;



// WEBPACK FOOTER //
// ./src/pages/captains/captains.component.js